/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Knp_Lookup_Save_ButtonInputs */

const en_knp_lookup_save_button = /** @type {(inputs: Knp_Lookup_Save_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Save`)
};

const fr_knp_lookup_save_button = /** @type {(inputs: Knp_Lookup_Save_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Enregistrer`)
};

const de_knp_lookup_save_button = /** @type {(inputs: Knp_Lookup_Save_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Speichern`)
};

const it_knp_lookup_save_button = /** @type {(inputs: Knp_Lookup_Save_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Salva`)
};

const ru_knp_lookup_save_button = /** @type {(inputs: Knp_Lookup_Save_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Сохранять`)
};

const es_knp_lookup_save_button = /** @type {(inputs: Knp_Lookup_Save_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ahorrar`)
};

const zh_cn2_knp_lookup_save_button = /** @type {(inputs: Knp_Lookup_Save_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`节省`)
};

const ja_knp_lookup_save_button = /** @type {(inputs: Knp_Lookup_Save_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`保存`)
};

const hi_knp_lookup_save_button = /** @type {(inputs: Knp_Lookup_Save_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`बचाना`)
};

const pt_pt2_knp_lookup_save_button = /** @type {(inputs: Knp_Lookup_Save_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Salvar`)
};

/**
* | output |
* | --- |
* | "Save" |
*
* @param {Knp_Lookup_Save_ButtonInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const knp_lookup_save_button = /** @type {((inputs?: Knp_Lookup_Save_ButtonInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Knp_Lookup_Save_ButtonInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_knp_lookup_save_button(inputs)
	if (locale === "de") return de_knp_lookup_save_button(inputs)
	if (locale === "it") return it_knp_lookup_save_button(inputs)
	if (locale === "ru") return ru_knp_lookup_save_button(inputs)
	if (locale === "es") return es_knp_lookup_save_button(inputs)
	if (locale === "zh-CN") return zh_cn2_knp_lookup_save_button(inputs)
	if (locale === "ja") return ja_knp_lookup_save_button(inputs)
	if (locale === "hi") return hi_knp_lookup_save_button(inputs)
	if (locale === "pt-PT") return pt_pt2_knp_lookup_save_button(inputs)
	return en_knp_lookup_save_button(inputs)
});